import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./aboutwrap.css"
import anime from 'animejs/lib/anime.es.js';

const AboutWrap = ( { sponsors, sponsorshipLevel }) => {

    const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    const [animation, setAnimation] = useState()
    const [animationPlayed, setAnimationPlayed] = useState(false)

    const showLearnMoreModal = () => setLearnMoreModalState(true)
    const hideLearnMoreModal = () => setLearnMoreModalState(false)

    const handleScroll = () => {
        let offset = window.document.getElementById("About").getElementsByClassName("date")[0].offsetTop
        let startPoint = offset - window.scrollY
        if( startPoint <= 380 && !animationPlayed){
            // console.log('handling scroll event!')
            animation.play()
            setAnimationPlayed(!animationPlayed)
        }
    }
    useEffect( ()=>{
        // console.log('setAnimation timeline')
        /*setAnimation(anime.timeline({
            targets: ['section.about .date', 'section.about .location'],
            easing: 'cubicBezier(.5, .05, .1, .3)',
            autoplay: false
        })
        .add({
            translateX: [999, 0],
            duration: 800,
            delay: anime.stagger( 100 ),
        })
        )*/
    }, [])
    useEffect( () => {
        /*window.sponsor = sponsors
        window.sponsorshipLevel = sponsorshipLevel
        // console.log('animejs scroll eventListener added')
        window.addEventListener( 'scroll', handleScroll)
        return () => {
            // console.log('animejs scroll eventListener removed')
            window.removeEventListener( 'scroll', handleScroll)
        }*/
    })
    return (
        <section className="about" id="About">
            <div className="containfix">
                
                <div className="grid gridContain">
                    <div className="column grid1">
                        <h1>Wrap-up</h1>
                        <p className="underabout">
                        
                        <a href="http://carahsoft.adobeconnect.com/p4lxbzgl0tr8/?OWASP_CSRFTOKEN=0821f9096306cd366be837a7942286a59b997ad1e0f4fd46286f8cfdce01ec3f" target="_blank" className="pinkify">Watch the livestream</a> from the first SNG Live Speaker Series of 2020. Over one hour, FedScoop’s Editor-In-Chief Billy Mitchell had two candid conversations with IT leaders, highlighting their progress and the major challenges they still face modernizing legacy systems.<br /><br />

In this session, Bill Zielinski, Assistant Commissioner for Information Technology in GSA’s Federal Acquisition Service and Daniel Prieto, Google Cloud’s Federal Government Strategic Executive discussed their insider’s approach to IT Modernization followed by Bill Marion, Air Force Deputy CIO who provided insights on the Air Force’s path to Joint all-domain operations.
                    </p>
                    
                    
                        
                        <p>
                            <a className="regmobwatch" href="http://carahsoft.adobeconnect.com/p4lxbzgl0tr8/?OWASP_CSRFTOKEN=0821f9096306cd366be837a7942286a59b997ad1e0f4fd46286f8cfdce01ec3f" target="_blank">WATCH NOW »</a>
                        </p>
                    </div>
                    <div class="column extra_text">
                        <a className="regworkwatch" href="http://carahsoft.adobeconnect.com/p4lxbzgl0tr8/?OWASP_CSRFTOKEN=0821f9096306cd366be837a7942286a59b997ad1e0f4fd46286f8cfdce01ec3f" target="_blank">WATCH NOW »</a>
                        
                    </div>
                    <div className="column grid3">
                        <div className="grouplogos">
                            <h1>SPONSORS</h1>
                            { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level && sponsor.event == "feb")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }

                        </div>
                        {/*<div className="botbuttons">
                            <h2 className="sponsor" id="Sponsors">BECOME A SPONSOR</h2>
                            <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                            <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>
                        </div>*/}
                    </div>
                </div>
            </div>
            <div className="sponsormob-mod" id="Sponsors">
                <div className="grouplogos">
                        <h1>SPONSORS</h1>
                        { sponsorshipLevel ? sponsorshipLevel.map( 
                                ( level, index )  => {
                                    let levelSponsors = sponsors.filter( sponsor => sponsor.level == level  && sponsor.event == "feb")
                                    let levelHasSponsors = levelSponsors.length > 0
                                    return ( 
                                        levelHasSponsors ? <div key={ index }>
                                            
                                            
                                            {levelSponsors.map( (sponsor, key ) => 
                                            <div className="logos">
                                                <a key={key}  href={sponsor.url} title={sponsor.name} target="_blank">
                                                    <img src={sponsor.logo} alt={sponsor.name} width={sponsor.width} />
                                                </a></div>)}
                                            
                                        </div>:
                                        false )
                                })
                                : <em>Missing sponsorshipLevel in gastsby-config.js</em>
                            }
                </div>
                        </div>
            <div className="sponsormob">
                <div className="containfix">
                    
                    {/*<h2 className="sponsor">BECOME A SPONSOR</h2>
                    <a className="pdf" href="https://s3.amazonaws.com/sng-global-web-assets/sponsors/SNGLIVE_SponsorPackageV2.pdf" target="_blank">DOWNLOAD PDF »</a>
                        <a className="contactus" href="mailto:sales@fedscoop.com" target="_blank">CONTACT US »</a>*/}
                </div>
            </div>
            
        </section>
    )
}

export default AboutWrap